import { defineMessages } from 'react-intl'

import { Appointment } from '../../../models/appointment/Appointment'
import { ProgramNames } from '../../../models/programs/Programs'
import { getProgramNameFromId } from '../../programConfigs/programHelpers'
import { LTSessionTypes } from '../constants'

const DBT_TEENS_SESSION_LABEL_MESSAGES = defineMessages({
  intake: {
    defaultMessage: 'Intake session',
    description: 'Member-facing label for a DBT Teens intake session',
  },
  followUp: {
    defaultMessage: 'Follow-up session',
    description: 'Member-facing label for a DBT Teens follow-up session',
  },
  family: {
    defaultMessage: 'Family session',
    description: 'Member-facing label for a DBT Teens family session',
  },
  caregiver: {
    defaultMessage: 'Caregiver session',
    description: 'Member-facing label for a DBT Teens caregiver session',
  },
  group: {
    defaultMessage: 'Group session',
    description: 'Member-facing label for a DBT Teens group session',
  },
  medication: {
    defaultMessage: 'Medication management session',
    description: 'Member-facing label for a DBT Teens medication management session',
  },
})

type DbtTeensSessionLabelAppointment = Pick<Appointment, 'programId' | 'sessionNumber' | 'sessionType'>

export const isDbtTeensTeenOnlySession = ({
  programId,
  sessionNumber,
  sessionType,
}: DbtTeensSessionLabelAppointment): boolean =>
  getProgramNameFromId(programId) === ProgramNames.DialecticalBehaviorTherapyTeens &&
  (sessionType === LTSessionTypes.DBT_TEENS_FOLLOWUP_SESSION ||
    ((sessionType == null || sessionType === LTSessionTypes.DBT_TEENS_SESSION) && sessionNumber !== 1))

export const getDbtTeensSessionLabel = ({ programId, sessionNumber, sessionType }: DbtTeensSessionLabelAppointment) => {
  if (getProgramNameFromId(programId) !== ProgramNames.DialecticalBehaviorTherapyTeens) {
    return undefined
  }

  switch (sessionType) {
    case LTSessionTypes.DBT_TEENS_INTAKE_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.intake
    case LTSessionTypes.DBT_TEENS_FOLLOWUP_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.followUp
    case LTSessionTypes.DBT_TEENS_MEDICATION_INITIAL_SESSION:
    case LTSessionTypes.DBT_TEENS_MEDICATION_FOLLOWUP_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.medication
    case LTSessionTypes.DBT_TEENS_FAMILY_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.family
    case LTSessionTypes.DBT_TEENS_CAREGIVER_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.caregiver
    case LTSessionTypes.DBT_TEENS_GROUP_SESSION:
      return DBT_TEENS_SESSION_LABEL_MESSAGES.group
    default:
      return sessionNumber === 1 ? DBT_TEENS_SESSION_LABEL_MESSAGES.intake : DBT_TEENS_SESSION_LABEL_MESSAGES.followUp
  }
}
